"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSnackbarContentOverrides = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, palette = _a.palette, spacing = _a.spacing;
    return ({
        root: (_b = {
                padding: spacing(2, 2, 2, 4),
                backgroundColor: palette.background.overlays,
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35)",
                color: undefined
            },
            _b[breakpoints.up("sm")] = {
                minWidth: undefined,
            },
            _b),
        message: {
            padding: spacing(2, 2, 2, 0),
            "& .MuiSvgIcon-root": {
                margin: "calc(-0.5em + " + spacing(2) + "px)",
            },
        },
        action: {
            paddingLeft: spacing(4),
            marginRight: undefined,
            "& .MuiButton-textPrimary": {
                color: palette.text.secondary,
            },
        },
    });
};
//# sourceMappingURL=MuiSnackbarContent.js.map